import { render, staticRenderFns } from "./summernote.vue?vue&type=template&id=0b624d09"
import script from "./summernote.vue?vue&type=script&lang=js"
export * from "./summernote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports